export default "__VITE_ASSET__429de428__"